<div class="flex flex-col h-full overflow-hidden rounded-2xl bg-surface-elevated">
  <header
    [appRefreshSurface]="refreshPhase"
    class="flex h-14 lg:h-[90px] items-center gap-2 px-6 py-8 w-full bg-surface-elevated border-b border-border-subtle">
    <div
      class="flex justify-between items-center gap-2 w-full"
      *ngIf="!loading">
      <div>
        <ng-container
          *ngIf="selectedConversation.customer?.name; else noTooltip">
          <div
            appTooltip
            [selectedConversation]="selectedConversation"
            [customerSales]="customerSales"
            [saleCount]="saleCount"
            [lastSaleDate]="lastSaleDate"
            [detailAddressUser]="detailAddressUser"
            [tooltipPosition]="'bottom'"
            class="flex gap-2">
            <span
              class="text-lg font-bold text-text gap-4"
              *ngIf="selectedConversation.customer">
              {{ selectedConversation.customer.name }}
              {{ selectedConversation.customer.last_name }}</span
            >
            <span
              class="text-lg font-bold text-text gap-4"
              *ngIf="!selectedConversation.customer">
              {{ selectedConversation.phone }}
            </span>

            <ng-container *ngIf="selectedConversation.customer?.name">
              <span class="text-[4px] pt-2.5">
                <i class="fa-solid fa-circle text-icon-secondary"></i>
              </span>
              <span class="text-lg text-text">
                {{ selectedConversation.phone }}</span
              >
            </ng-container>
          </div>
        </ng-container>
        <ng-template #noTooltip>
          <span
            class="text-lg font-bold text-text gap-4"
            *ngIf="selectedConversation.customer">
            {{ selectedConversation.customer.name }}
            {{ selectedConversation.customer.last_name }}</span
          >
          <span
            class="text-lg font-bold text-text gap-4"
            *ngIf="!selectedConversation.customer">
            {{
              selectedConversation.name
                ? selectedConversation.name + ' · '
                : ''
            }}{{ selectedConversation.phone }}
          </span>
        </ng-template>

        <div class="flex items-center gap-2 mt-2">
          <div
            class="flex items-center text-sm"
            *ngIf="selectedConversation.is_assistance_required === true">
            <div class="flex tag tagAssistance">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="currentColor">
                <path
                  d="M13.5607 10.3125L7.84729 0.5625C7.40988 -0.1875 6.30604 -0.1875 5.86568 0.5625L0.154965 10.3125C-0.284589 11.0598 0.262884 12 1.14389 12H12.5707C13.4482 12 13.9973 11.0625 13.5607 10.3125ZM6.21336 3.64286C6.21336 3.28795 6.5013 3 6.85621 3C7.21113 3 7.49907 3.28929 7.49907 3.64286V7.07143C7.49907 7.42634 7.21113 7.71429 6.88032 7.71429C6.54952 7.71429 6.21336 7.42768 6.21336 7.07143V3.64286ZM6.85621 10.2857C6.39121 10.2857 6.01407 9.90857 6.01407 9.44357C6.01407 8.97857 6.39095 8.60143 6.85621 8.60143C7.32148 8.60143 7.69836 8.97857 7.69836 9.44357C7.69729 9.90804 7.32229 10.2857 6.85621 10.2857Z" />
              </svg>
              <span>Asistencia</span>
            </div>
          </div>
          <div
            class="flex items-center text-sm"
            *ngIf="selectedConversation.is_bot_enabled === false">
            <div class="flex tag tagBot">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="12"
                viewBox="0 0 25 12"
                fill="currentColor">
                <path
                  d="M23.75 6.71484C23.0137 6.71484 22.7562 7.23477 22.6941 7.33984H21.25V2.99961C21.25 1.62305 20.1289 0.5 18.75 0.5H6.25C4.875 0.5 3.75 1.62305 3.75 2.99961V7.37461H2.30586C2.24375 7.26953 1.98633 6.71484 1.25 6.71484C0.535156 6.71484 0 7.29961 0 7.96484C0 8.63125 0.535937 9.17969 1.25 9.17969C1.98633 9.17969 2.24336 8.66016 2.30586 8.58984H3.75V14.1797C3.75 15.5566 4.87305 16.6445 6.25 16.6445L8.75 16.6449V19.9258C8.75 20.3086 8.97656 20.5 9.21875 20.5C9.31258 20.5 9.40805 20.4726 9.49594 20.4091L14.375 16.7148L18.75 16.7145C20.127 16.7145 21.25 15.5914 21.25 14.2496V8.58984H22.6945C22.7578 8.73047 23.0156 9.21484 23.75 9.21484C24.4648 9.21484 25 8.63047 25 8C25 7.33203 24.4648 6.71484 23.75 6.71484ZM20 14.2148C20 14.9023 19.4375 15.4297 18.75 15.4297H14.3711C14.1005 15.4297 13.8371 15.5174 13.6207 15.6798L10 18.4336V16.125C10 15.7798 9.72016 15.5352 9.375 15.5352H6.25C5.5625 15.5352 5 14.9727 5 14.3203V11.75H20V14.2148ZM20 10.5H5V5.5H20V10.5ZM20 4.25H5V2.99961C5 2.31211 5.5625 1.78477 6.25 1.78477H18.75C19.4375 1.78477 20 2.34727 20 2.99961V4.25ZM8.75 9.21484C9.44023 9.21484 10 8.65508 10 7.96484C10 7.27461 9.44023 6.71484 8.75 6.71484C8.05977 6.71484 7.5 7.27461 7.5 7.96484C7.5 8.69141 8.05859 9.21484 8.75 9.21484ZM16.25 9.21484C16.9402 9.21484 17.5 8.65508 17.5 7.96484C17.5 7.27461 16.9402 6.71484 16.25 6.71484C15.5598 6.71484 15 7.27461 15 7.96484C15 8.69141 15.5586 9.21484 16.25 9.21484Z" />
              </svg>
              <span>Bot apagado</span>
            </div>
          </div>
          <div class="flex items-center text-sm">
            <div class="flex tag {{ conversationStep?.name }}">
              <i class="fa {{ conversationStep?.icon }}"></i>
              <span>{{ conversationStep?.label }}</span>
            </div>
          </div>
          <a
            *ngIf="saleUrl"
            [href]="saleUrl"
            target="_blank"
            rel="noopener"
            class="flex items-center text-sm tag bg-surface-brand-subtle text-text-brand hover:underline">
            <i class="fa-solid fa-receipt"></i>
            <span>Ver orden #{{ selectedConversation.sale_id }}</span>
          </a>
        </div>
      </div>

      <div class="flex space-x-2 items-center gap-4">
        <button
          *ngIf="selectedConversation.is_assistance_required"
          (click)="markReady()"
          [disabled]="isLoadingConversationAssistant"
          [class.disabled]="isLoadingConversationAssistant"
          class="h-10 px-4 flex items-center justify-center font-medium bg-surface-brand text-text-on-brand rounded-md hover:bg-surface-brand-hover active:bg-surface-brand-pressed active:scale-[0.97] transition duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-border-focus disabled:opacity-60 disabled:pointer-events-none">

          <svg
            *ngIf="!isLoadingConversationAssistant"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            class="mr-2">
            <path
              d="M7.61875 10.6187C7.27813 10.9594 6.72187 10.9594 6.38125 10.6187L4.38125 8.61875C4.04063 8.27812 4.04063 7.72187 4.38125 7.38125C4.72187 7.04063 5.27813 7.04063 5.61875 7.38125L7 8.7625L10.3813 5.38125C10.7219 5.04063 11.2781 5.04063 11.6187 5.38125C11.9594 5.72187 11.9594 6.27813 11.6187 6.61875L7.61875 10.6187ZM16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8ZM8 1.5C4.40938 1.5 1.5 4.40938 1.5 8C1.5 11.5906 4.40938 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40938 11.5906 1.5 8 1.5Z"
              fill="#eafbef" />
          </svg>
          <div *ngIf="isLoadingConversationAssistant" class="">
            Cargando...
            <!-- <app-loader></app-loader> -->
          </div>
          <div *ngIf="!isLoadingConversationAssistant" class="leading-none">
            Marcar como resuelto
          </div>
        </button>
        <button
          (click)="
            onAiBotStatusChange(
              selectedConversation.is_bot_enabled ? false : true
            )
          "
          class="h-10 border text-text font-medium px-4 rounded-md bg-surface-elevated hover:bg-surface-subtle active:scale-[0.97] transition duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-border-focus"
          [ngClass]="
            selectedConversation.is_bot_enabled
              ? 'border-border-error'
              : 'border-border-brand'
          ">
          <i
            class="fa-solid fa-circle text-xs"
            [ngClass]="
              selectedConversation.is_bot_enabled
                ? 'text-icon-error'
                : 'text-icon-brand'
            "></i>

          <span class="ml-2">
            {{ selectedConversation.is_bot_enabled ? 'Desactivar' : 'Activar' }}
            bot
          </span>
        </button>
      </div>
    </div>
  </header>
  <main
    #mainContainer
    [appRefreshSurface]="refreshPhase"
    class="flex flex-col gap-4 p-4 md:gap-8 md:p-6 overflow-auto bg-surface-subtle dark:bg-surface-default flex-1"
    appInfiniteScroll
    scrollDirection="up"
    (scrollUp)="loadMoreMessages ? loadMoreConversationMessages() : ''">
    <div *ngIf="loading" class="flex justify-center items-center pt-28">
      <app-loader [width]="400" [height]="400"></app-loader>
    </div>
    <ng-container *ngIf="!loading">
      <app-message-bubble
        [selectedConversation]="selectedConversation"
        [message]="message"
        [isBot]="message.isBot"
        *ngFor="let message of messages; trackBy: trackByMessage">
      </app-message-bubble>
    </ng-container>
  </main>
  <footer
    class="flex lg:h-[72px] items-center gap-4 bg-surface-elevated border-t border-border-subtle px-8">
    <input
      (keydown.enter)="onButtonClick()"
      [(ngModel)]="messageText"
      [disabled]="!chatInputIsEnabled()"
      class="flex h-10 w-full rounded-lg px-4 py-4 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 disabled:cursor-not-allowed flex-1 shadow-none appearance-none pl-2 md:w-2/3 lg:w-1/3 bg-surface-muted"
      [placeholder]="chatInputPlaceholder"
      [ngClass]="
        selectedConversation.is_bot_enabled
          ? 'text-text-shy dark:text-supporting-text'
          : 'placeholder-supporting-text dark:placeholder-text dark:text-text '
      "
      type="text" />
    <button
      [disabled]="!chatInputIsEnabled() || isMessageSending"
      (click)="onButtonClick()"
      [class.disabled]="!chatInputIsEnabled() || isMessageSending"
      class="group inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition duration-150 active:scale-[0.97] active:bg-surface-brand-pressed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 disabled:pointer-events-none h-10 w-10 bg-surface-brand hover:bg-surface-brand-hover text-text-on-brand">
      <div *ngIf="isMessageSending" class="loader-button"></div>
      <svg
        *ngIf="!isMessageSending"
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="currentColor"
        class="transition-transform duration-150 ease-out-quart group-hover:translate-x-0.5 group-active:translate-x-1">
        <path
          d="M16.2023 7.09503L2.20256 1.09484C2.07569 1.04047 1.94194 0.985779 1.80944 0.985779C1.53998 0.985779 1.27508 1.09512 1.08133 1.29984C0.793267 1.63295 0.726871 2.08576 0.914368 2.46106L3.80878 8.01377L0.914462 13.5668C0.726965 13.9424 0.79337 14.3949 1.08146 14.7002C1.27483 14.9048 1.53957 15.0143 1.80894 15.0143C1.94175 15.0143 2.07553 14.9879 2.20237 14.9332L16.2023 8.9325C16.5704 8.77528 16.8088 8.41345 16.8088 8.01345C16.7804 7.61377 16.571 7.25128 16.2023 7.09503ZM1.80819 2.01482C1.80757 2.01513 1.80851 2.0142 1.80819 2.01482L14.6429 7.51378H4.67439L1.80819 2.01482ZM1.80101 14.0293L4.67439 8.51376H14.6148L1.80101 14.0293Z" />
      </svg>
    </button>
  </footer>
</div>
